import React from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import sr from '../../scroll-reveal'

class Services extends React.Component {
    componentDidMount() {
        sr.reveal('.service-icon', {
            duration: 600,
            scale: 0.3,
            distance: '0px'
        }, 200);
    }

    render() {
        return (
            <section id="services">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 text-center">
                            <h2 className="section-heading">
                                Tailoring The Right Solution For Our Clients
                            </h2>
                            <hr className="my-4"/>
                            <p>
                                Novotec strives to craft the right solution for our clients. To do this, we embed our
                                technologists within their teams to collaboratively achieve this goal while leaving the
                                intellectual property safely in the customer's hands.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-3 col-md-6 text-center">
                            <div className="service-box mt-5 mx-auto">
                                <span className="service-icon">
                                    <FontAwesomeIcon className="fa-4x text-primary mb-3"
                                                     icon={["fas", "code"]}/>
                                </span>
                                <h3 className="mb-3">Software Engineering</h3>
                                <p className="text-muted mb-0">
                                    We offer software solutions using the latest technologies in various coding
                                    languages and frameworks. Some of our specialties are: Java (Spring), Ruby (Rails),
                                    and Javascript (Angular, React).
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 text-center">
                            <div className="service-box mt-5 mx-auto">
                                <span className="service-icon">
                                    <FontAwesomeIcon className="fa-4x text-primary mb-3 service-icon"
                                                     icon={["fab", "aws"]}/>
                                </span>
                                <h3 className="mb-3">Amazon Web Services (AWS)</h3>
                                <p className="text-muted mb-0">
                                    Many are making the move to AWS, we can help you make this move! We provide the
                                    expertise to transition existing software and/or get new applications and services
                                    into the cloud.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 text-center">
                            <div className="service-box mt-5 mx-auto">
                                <span className="service-icon">
                                    <FontAwesomeIcon className="fa-4x text-primary mb-3 service-icon"
                                                     icon={["fas", "cogs"]}/>
                                </span>
                                <h3 className="mb-3">DevOps Automation (CI/CD)</h3>
                                <p className="text-muted mb-0">
                                    Get your software to build, test, and deploy automatically. We are advocates of
                                    continuously integrating and deploying which helps build high-quality and more
                                    resilient software.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 text-center">
                            <div className="service-box mt-5 mx-auto">
                                <span className="service-icon">
                                    <FontAwesomeIcon className="fa-4x text-primary mb-3 service-icon"
                                                     icon={["fas", "tasks"]}/>
                                </span>
                                <h3 className="mb-3">Agile Software Development</h3>
                                <p className="text-muted mb-0">
                                    We do and advocate for <u><b>real</b></u> agile development. We believe the agile
                                    methodology, when done right, allows the software development process to adapt and
                                    ultimately build the right solution for you.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 text-center">
                            <br/> <br/>
                            <a className="btn btn-primary btn-xl js-scroll-trigger" href="#contact">
                                Sound Good? Lets Get Started!
                            </a>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default Services;


// WEBPACK FOOTER //
// ./src/js/App/Services/Services.js